import React, { useEffect, useRef } from 'react';
import './AlertModal.scss'; // Make sure this points to your updated SCSS
import { useAlertModalContent } from '../../../Slice';
import { ClosePopup } from '../../../assets/images';

function AlertModalRoot() {
   const modalRef = useRef(null);
   const modalContent = useAlertModalContent() || {};

   const {
      title,
      visible,
      onRequestClose,
      noButton,
      noAction,
      yesButton,
      yesAction,
      optionalButton,
      optionalAction,
      description,
      icon,
      customClassName,
   } = modalContent;

   useEffect(() => {
      const handleClickOutside = event => {
         if (modalRef.current && !modalRef.current.contains(event.target)) {
            onRequestClose?.();
         }
      };

      if (visible) {
         document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, [visible, onRequestClose]);

   if (!visible) return null;

   return (
      <div className="alert-modal-backdrop">
         <div className={`alert-modal-content ${customClassName} ${!description ? 'withoutdesc' : ""}`} ref={modalRef}>
            {icon && <div className="alert-modal-icon ct-flexCenter">{icon}</div>}
            <div className="popup_close">
               {title && <h3 className="alert-modal-title">{title}</h3>}
               <i onClick={() => {
                     noAction?.();
                     onRequestClose?.();
                  }}>
                  <ClosePopup />
               </i>
            </div>
            {description && <p className="alert-modal-description">{description}</p>}

            <div className="alert-modal-buttons-container">
               <div className="alert-modal-buttons">
                  {noButton && (
                     <button
                        className="alert-button"
                        onClick={() => {
                           noAction?.();
                           onRequestClose?.();
                        }}>
                        {noButton}
                     </button>
                  )}
                  {optionalButton && (
                     <div className="alert-modal-optional">
                        <button className="alert-button optional-btn" onClick={optionalAction}>
                           {optionalButton}
                        </button>
                     </div>
                  )}
                  {yesButton && (
                     <button
                        className="alert-button alert-button-primary"
                        onClick={() => {
                           yesAction?.();
                           onRequestClose?.();
                        }}>
                        {yesButton}
                     </button>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
}

export default AlertModalRoot;
